module.exports = __webpack_public_path__ + "static/media/DekoSchal_35586.ddc01107.png";